/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseType: NonNullable<unknown> }} Case_Type_LabelInputs */

const en_case_type_label = /** @type {(inputs: Case_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.caseType === "third_party_claim") return /** @type {LocalizedString} */ (`Third-party claim`);
	if (i?.caseType === "road_conditions") return /** @type {LocalizedString} */ (`Road conditions accident`);
	if (i?.caseType === "zero_km_warranty") return /** @type {LocalizedString} */ (`Vehicle warranty`);
	if (i?.caseType === "routine_maintenance") return /** @type {LocalizedString} */ (`Routine maintenance repair`);
	if (i?.caseType === "hidden_defect") return /** @type {LocalizedString} */ (`Hidden defect`);
	if (i?.caseType === "debt_collection") return /** @type {LocalizedString} */ (`Debt collection`);
	return /** @type {LocalizedString} */ (`${i?.caseType}`)
	
};

const pt_br2_case_type_label = /** @type {(inputs: Case_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.caseType === "third_party_claim") return /** @type {LocalizedString} */ (`Sinistro com terceiro`);
	if (i?.caseType === "road_conditions") return /** @type {LocalizedString} */ (`Acidente — condições da via`);
	if (i?.caseType === "zero_km_warranty") return /** @type {LocalizedString} */ (`Veículo em garantia`);
	if (i?.caseType === "routine_maintenance") return /** @type {LocalizedString} */ (`Manutenção — reparo de rotina`);
	if (i?.caseType === "hidden_defect") return /** @type {LocalizedString} */ (`Defeito oculto`);
	if (i?.caseType === "debt_collection") return /** @type {LocalizedString} */ (`Cobrança de dívida`);
	return /** @type {LocalizedString} */ (`${i?.caseType}`)
	
};

/**
* | caseType | output |
* | --- | --- |
* | "third_party_claim" | "Third-party claim" |
* | "road_conditions" | "Road conditions accident" |
* | "zero_km_warranty" | "Vehicle warranty" |
* | "routine_maintenance" | "Routine maintenance repair" |
* | "hidden_defect" | "Hidden defect" |
* | "debt_collection" | "Debt collection" |
* | * | "{caseType}" |
*
* @param {Case_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_type_label = /** @type {((inputs: Case_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_type_label(inputs)
	return pt_br2_case_type_label(inputs)
});